import React, { Component } from 'react';
import moment from 'moment';
import { compose } from '../../reactApolloCompat';
import { withRouter } from '../../utils/withRouter';
import withStyles from '@mui/styles/withStyles';
import { withSnackbarMessage } from '../../context/SnackbarMessage';
import MetricsAshes from './MetricsAshes';
import '../../components/metrics/css/metrics.scss';
import NotFound from '../NotFound';
import { getUser } from '../../utils/sessions';
import GatedComponent from '../../components/GatedComponent';
import StaffAutoComplete from '../../components/form/StaffAutoComplete';
import { dateTimeToString, dateToString } from '../../utils/date';
import Inline, { inlineAlignment } from '../../components/layout/Inline';
import Select from '../../components/form/Select';
import ViewHeader from '../../components/header/ViewHeader';
import Grid from '../../components/layout/Grid';
import { withErrorBoundary } from '@sentry/react';
import ErrorFallback from '../../components/ErrorFallback';

class Metrics extends Component {
    state = {};

    render() {
        const { history } = this.props;
        const currentUser = getUser();
        const requestedMetrics = new URLSearchParams(window.location.search);

        const period = (requestedMetrics && requestedMetrics.get('period')) || 'month';
        const urlStart = requestedMetrics && requestedMetrics.get('start');
        const myStart = (urlStart && moment(urlStart).isValid() ? moment(urlStart) : moment()).startOf('month');

        let periodStart = moment(myStart).startOf(period);
        if (period === 'year') {
            if (moment(myStart).quarter() > 2) {
                periodStart = moment(periodStart).add(6, 'months');
            } else {
                periodStart = moment(periodStart).subtract(6, 'months');
            }
        }
        let periodUntil = moment(periodStart)
            .add(1, period)
            .subtract(1, 'second');

        const periodValues = () => {
            const dateArray = [];
            const curr = moment('2019-07-01'); // history begins here!
            const now = moment();
            let format = 'MMM Y';
            if (period === 'quarter') {
                format = 'Qo [Quarter] Y';
            }
            while (curr < now) {
                dateArray.push({
                    label:
                        period === 'year'
                            ? moment(curr).format('Y') +
                            ' - ' +
                            moment(curr)
                                .add(1, period)
                                .format('Y')
                            : moment(curr).format(format),
                    value: moment(curr).format('Y-MM-DD')
                });
                curr.add(1, period);
            }
            return dateArray;
        };

        const periodValue = () => {
            const expectedValues = periodValues();
            const selected = dateToString(myStart);
            const good = expectedValues.find(e => e.value === selected);
            if (good) return good; // user picked a proper date!
            const goodEnough = expectedValues.find(e => e.value > selected);
            if (goodEnough) return goodEnough; // user's date near a proper date, show nearest before.
            return expectedValues[expectedValues.length - 1]; // user picked some future date, just show latest.
        };

        const periodData = {
            team: null,
            type: period,
            label: periodValue().label,
            start: dateTimeToString(periodStart),
            until: dateTimeToString(periodUntil),
            userID: currentUser.ID
        };

        return (
            <GatedComponent canEditCode="FM_ACCESS_Metrics">
                {(isEnabled, data) => {
                    if (!isEnabled) return <NotFound />;
                    const viewOptions = [];
                    const { readCurrentUser } = data;
                    const { AllPermissions } = readCurrentUser || null;
                    if (AllPermissions.indexOf('ADMIN') < 0) {
                        const { Groups } = readCurrentUser || [];
                        // TODO: proper permissions
                        if (Groups.find(e => e.Code === 'cm-users'))
                            viewOptions.push({ label: 'Ash Collection Metrics', value: 'ashes' });
                    } else {
                        periodData.userID = (requestedMetrics && requestedMetrics.get('user')) || currentUser.ID;
                        viewOptions.push({ label: 'Ash Collection Metrics', value: 'ashes' });
                    }

                    const viewSelected = (requestedMetrics && requestedMetrics.get('view')) || 'ashes';
                    const view =
                        (viewOptions.length && (viewOptions.length === 1 ? viewOptions[0].value : viewSelected)) ||
                        null;
                    periodData.team = view;

                    if (!(view === 'ashes')) return <NotFound />;

                    return (
                        <div className="metrics-page">
                            <Grid container>
                                <Grid item>
                                    <Inline className="metrics" alignment={inlineAlignment.rightAlignSiblings} center>
                                        <ViewHeader
                                            title="Performance Metrics"
                                            subtitle={(view === 'ashes' && 'Ash Collections') || ''}
                                        />
                                        {!!view && (
                                            <Inline>
                                                {AllPermissions.indexOf('ADMIN') >= 0 && (
                                                    <span style={{ minWidth: 200, width: '100%' }}>
                                                        <StaffAutoComplete
                                                            defaultMe
                                                            preloadAll
                                                            value={periodData.userID}
                                                            label="Person"
                                                            limit={100}
                                                            selectProps={{ multiple: false }}
                                                            clearOnSelect={false}
                                                            onSelect={(_, result) => {
                                                                //if (result && result.ID > 0) {
                                                                requestedMetrics.set('user', result.ID);
                                                                history.push('?' + requestedMetrics.toString());
                                                                // }
                                                            }}
                                                        />
                                                    </span>
                                                )}
                                                {viewOptions.length > 1 && (
                                                    <Select
                                                        label="View"
                                                        allowNone={false}
                                                        options={viewOptions}
                                                        value={view}
                                                        onChange={e => {
                                                            requestedMetrics.set('view', e.target.value);
                                                            history.push('?' + requestedMetrics.toString());
                                                        }}
                                                    />
                                                )}
                                                <Select
                                                    label="Period"
                                                    allowNone={false}
                                                    options={[
                                                        { label: 'Financial Year', value: 'year' },
                                                        { label: 'Quarterly', value: 'quarter' },
                                                        { label: 'Monthly', value: 'month' }
                                                    ]}
                                                    value={period}
                                                    onChange={e => {
                                                        requestedMetrics.set('period', e.target.value);
                                                        requestedMetrics.set('start', moment(myStart).format('Y-MM-DD'));
                                                        history.push('?' + requestedMetrics.toString());
                                                    }}
                                                />

                                                <Select
                                                    label={period}
                                                    allowNone={false}
                                                    options={periodValues()}
                                                    value={periodValue().value}
                                                    onChange={e => {
                                                        requestedMetrics.set('start', e.target.value);
                                                        history.push('?' + requestedMetrics.toString());
                                                    }}
                                                />
                                            </Inline>
                                        )}
                                    </Inline>
                                </Grid>
                            </Grid>
                            {periodData.userID > 0 ? (
                                (view === 'ashes' && <MetricsAshes period={periodData} />) || <NotFound />
                            ) : (
                                <Grid container><Grid><p>Please select a staff member.</p></Grid></Grid>
                            )}
                        </div>
                    );
                }}
            </GatedComponent>
        );
    }
}

const styles = ({ spacing, typography, palette }) => ({
    paper: {
        padding: spacing(3)
    },
    pageTitle: {
        color: palette.text.primary
    },
    header: {
        fontWeight: typography.fontWeightLight,
        marginLeft: 16,
        paddingLeft: 16,
        borderLeft: '1px solid ' + palette.text.primary,
        color: palette.text.primary
    },
    tableData: {
        marginTop: '1rem'
    }
});

export default withErrorBoundary(compose(withRouter, withSnackbarMessage, withStyles(styles))(Metrics), { fallback: ErrorFallback });
